/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomerShoppingCartBookListBookCartDto model module.
 * @module model/CustomerShoppingCartBookListBookCartDto
 * @version v1.0.0
 */
class CustomerShoppingCartBookListBookCartDto {
    /**
     * Constructs a new <code>CustomerShoppingCartBookListBookCartDto</code>.
     * @alias module:model/CustomerShoppingCartBookListBookCartDto
     */
    constructor() { 
        
        CustomerShoppingCartBookListBookCartDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomerShoppingCartBookListBookCartDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomerShoppingCartBookListBookCartDto} obj Optional instance to populate.
     * @return {module:model/CustomerShoppingCartBookListBookCartDto} The populated <code>CustomerShoppingCartBookListBookCartDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomerShoppingCartBookListBookCartDto();

            if (data.hasOwnProperty('annual')) {
                obj['annual'] = ApiClient.convertToType(data['annual'], 'String');
            }
            if (data.hasOwnProperty('bookIsbn')) {
                obj['bookIsbn'] = ApiClient.convertToType(data['bookIsbn'], 'String');
            }
            if (data.hasOwnProperty('bookName')) {
                obj['bookName'] = ApiClient.convertToType(data['bookName'], 'String');
            }
            if (data.hasOwnProperty('isChecked')) {
                obj['isChecked'] = ApiClient.convertToType(data['isChecked'], 'Boolean');
            }
            if (data.hasOwnProperty('quantity')) {
                obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} annual
 */
CustomerShoppingCartBookListBookCartDto.prototype['annual'] = undefined;

/**
 * @member {String} bookIsbn
 */
CustomerShoppingCartBookListBookCartDto.prototype['bookIsbn'] = undefined;

/**
 * @member {String} bookName
 */
CustomerShoppingCartBookListBookCartDto.prototype['bookName'] = undefined;

/**
 * @member {Boolean} isChecked
 */
CustomerShoppingCartBookListBookCartDto.prototype['isChecked'] = undefined;

/**
 * @member {Number} quantity
 */
CustomerShoppingCartBookListBookCartDto.prototype['quantity'] = undefined;






export default CustomerShoppingCartBookListBookCartDto;

